import api from "./api"
import { FarmerPayload, PaginatedResponse, Farmer } from "../types"

export const farmerService = {

  async registerWithPayload(payload: FarmerPayload) {
    const { data } = await api.post("/farmers", payload)
    return data
  },

  async getAll(params?: {
    search?: string
    region_id?: number
    tree_type_id?: number
    page?: number
    per_page?: number
  }): Promise<PaginatedResponse<Farmer>> {
    const { data } = await api.get("/farmers", { params })
    return data
  },

  async getById(id: number): Promise<Farmer> {
    const { data } = await api.get(`/farmers/${id}`)
    return data.farmer
  },

  async update(id: number, payload: Partial<FarmerPayload>): Promise<Farmer> {
    const { data } = await api.put(`/farmers/${id}`, payload)
    return data.farmer
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/farmers/${id}`)
  },
}